export const sidebarLinks = [
    {
        url: ["/home"],
        label: "PageTitles.home",
    },
    {
        label: "PageTitles.sor_malattie",
        children: [
            {
                label: "PageTitles.gestisci_segnalazioni",
                url: ["/ricercaSegnalazioni", "/wizardSegnalazione"],
            },
            {
                label: "PageTitles.gestisci_focolai",
                url: [
                    "/ricercaFocolai",
                    "/associaSegnalazioni",
                    "/InformazioniFocolaio",
                ],
            },
            {
                label: "PageTitles.gestisci_contactTracing",
                url: ["/ricercaContactTracing", "/wizardSegnalazione"],
            },
        ],
    },
    {
        label: "PageTitles.monitoraggio",
        children: [
            {
                label: "PageTitles.vis_segnalazioni",
                url: ["/visualizzaSegnalazioni"],
            },
            {
                label: "PageTitles.trend_segnalazioni",
                url: ["/trendSegnalazioni"],
            },
            {
                label: "PageTitles.ins_segnalazione",
                url: ["/inserimentoSegnalazioni"],
            },
            {
                label: "PageTitles.inv_schedeSpeciali",
                url: ["/invioSchedeSpeciali"],
            },
            {
                label: "PageTitles.inv_premal",
                url: ["/statoInvioPremal"],
            },
            {
                label: "PageTitles.export_segnalazioni",
                url: ["/exportSegnalazioni"],
            },
            {
                label: "PageTitles.export_arbovirosi",
                url: ["/exportArbovirosi"],
            },
        ],
    },
    {
        label: "PageTitles.utilita",
        children: [
            {
                label: "PageTitles.report_statistici",
                url: ["/reportStatistici"],
            },
            {
                label: "PageTitles.gestione_destinatari",
                url: ["/gestioneDestinatari"],
            },
            {
                label: "PageTitles.exp_segnalazioni",
                url: ["/page8"],
            },
            {
                label: "PageTitles.errori_premal",
                url: ["/erroriPremal"],
            },
            {
                label: "PageTitles.gestione_malattie",
                url: ["/gestioneMalattie"],
            },
            {
                label: "PageTitles.gestione_medici",
                url: ["/gestioneMedici"],
            },
        ],
    },
    {
        label: "PageTitles.manuali",
        children: [
            {
                label: "PageTitles.manuale_def_caso",
                url: ["/manuali"],
            },
        ],
    },
    {
        label: "PageTitles.sorveglianza_hiv",
        children: [
            {
                label: "PageTitles.ricerca_segnalazioni_hiv",
                url: "/ricercaSegnalazioniHIV",
            },
            {
                label: "PageTitles.inserisci_segnalazione_hiv",
                url: "/formHIV",
            },
        ],
    },
    {
        label: "PageTitles.utilita_hiv",
        children: [
            {
                label: "PageTitles.gestione_duplicati_hiv",
                url: "/gestioneDuplicatiHIV",
            },
        ],
    },
];
export const navbarLink = [
    {
        label: "PageTitles.sor_malattie",
        pagine: "/ricercaSegnalazioni/ricercaFocolai/ricercaContactTracing/wizardSegnalazione/InformazioniFocolaio",
    },
    {
        label: "PageTitles.monitoraggio",
        pagine: "/inserimentoSegnalazioni/invioSchedeSpeciali/esitoTBC/statoInvioPremal/exportSegnalazioni",
    },
    {
        label: "PageTitles.utilita",
        pagine: "/reportStatistici/gestioneDestinatari/esportaSegnalazioni/erroriPremal/gestioneMalattie/gestioneMedici/reportEpatite",
    },
    {
        label: "PageTitles.manuali",
        pagine: "/manuali",
    },
];

export const navbarLinksHIV = [
    {
        label: "PageTitles.sorveglianza_hiv",
        pagine: "/ricercaSegnalazioniHIV/formHIV",
    },
    {
        label: "PageTitles.utilita_hiv",
        pagine: "/gestioneDuplicatiHIV",
    },
];

export const SorveglianzaMalattieDropdownList = [
    {
        label: "PageTitles.gestisci_segnalazioni",
        url: "/ricercaSegnalazioni",
    },
    {
        label: "PageTitles.gestisci_focolai",
        url: "/ricercaFocolai",
    },
    {
        label: "PageTitles.gestisci_contactTracing",
        url: "/ricercaContactTracing",
    },
];

export const MonitoraggioDropdownList = [
    {
        label: "PageTitles.ins_segnalazione",
        url: "/inserimentoSegnalazioni",
    },
    {
        label: "PageTitles.integrazioni_LIS",
        url: "/integrazioniLIS",
    },
    {
        label: "PageTitles.segnalazioni_da_LIS",
        url: "/segnalazioniDaLIS",
    },
    {
        label: "PageTitles.inv_schedeSpeciali",
        url: "/invioSchedeSpeciali",
    },
    {
        label: "PageTitles.esito_tbc",
        url: "/esitoTBC",
    },
    {
        label: "PageTitles.inv_premal",
        url: "/statoInvioPremal",
    },
    {
        label: "PageTitles.export_segnalazioni",
        url: "/exportSegnalazioni",
    },
    {
        label: "PageTitles.export_arbovirosi",
        url: "/exportArbovirosi",
    },
];

export const UtilitaDropdownList = [
    {
        label: "PageTitles.report_statistici",
        url: "/reportStatistici",
    },
    {
        label: "PageTitles.report_epatite",
        url: "/reportEpatite",
    },
];

export const ManualiDropdownList = [
    {
        label: "PageTitles.manuale_def_caso",
        url: "/manuali",
        id: "1"
    },
];


export const SegnalazioniHivDropDownList = [
    {
        label: "PageTitles.ricerca_segnalazioni",
        url: "/ricercaSegnalazioniHIV",
    },
    {
        label: "PageTitles.ins_segnalazioni",
        url: "/formHIV",
    },
];

export const UtilitaHivDropdownList = [
    {
        label: "PageTitles.gestione_duplicati",
        url: "/gestioneDuplicatiHIV",
    },
];
